import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../../components/constant_api";
import { getCurrentLoginUserId } from "../../components/Helpers/helpers";

export const settingsApi = createApi({
  reducerPath: "settingsApi",

  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
  }),

  tagTypes: ["Settings"],

  endpoints: (builder) => ({
    // GET SETTINGS
    getSettings: builder.query({
      query: (OrganisationID) =>
        `/permission/permission-config?OrganisationID=${OrganisationID}`,

      transformResponse: (response) => response?.data || {},

      providesTags: ["Settings"],
    }),

    // UPDATE SETTINGS
    updateSettings: builder.mutation({
      query: ({ OrganisationID, payload }) => ({
        url: `/permission/permission-config`,
        method: "POST",
        body: {
          OrganisationID,
          currentUserId: getCurrentLoginUserId(),
          ...payload,
        },
      }),

      invalidatesTags: ["Settings"],
    }),
  }),
});

export const { useGetSettingsQuery, useUpdateSettingsMutation } = settingsApi;
